import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import {
  checkIsReschedule,
  getSelectedAddOnData,
  getToken,
  tokenIsValid,
  getUserPrimaryEmail,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from './Function';
import './LinkButton.css';
// import { TotalBusFareContext, BusFareDepartContext, BusFareReturnContext, BusFareAddOnContext, LoyaltyDiscountContext  } from '../UserContext';
import {
  LoyaltyDiscountContext,
  LoyaltyIDContext,
  VoucherCodeContext,
  VoucherCodeAirlineContext,
  InsuranceAddonContext,
  HealthCareAddOnContext,
  CurrentCurrencyContext,
  ValueMealAddonContext,
} from '../UserContext';
import { LoadingScreenModal } from './LoadingScreenModal';
import * as CryptoJS from 'crypto-js';
import moment from 'moment';

export const CompletedBookingButton = ({
  guests,
  primary_guest_contact,
  primary_guest_email,
  depart,
  destination,
  depart_date,
  return_date,
  passenger_count,
  depart_trip_key,
  return_trip_key,
  currency,
  phone_country_code,
}) => {
  const children = 'Complete Booking';
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const { LoyaltyID, setLoyaltyID } = useContext(LoyaltyIDContext);
  const { TotalLoyalty, setLoyalty } = useContext(LoyaltyDiscountContext);
  const { VoucherCode, setVoucherCode } = useContext(VoucherCodeContext);
  const { VoucherCodeAirlineNo, setVoucherCodeAirlineNo } = useContext(
    VoucherCodeAirlineContext,
  );
  const { insuranceAddOn, setInsuranceAddOn } = useContext(
    InsuranceAddonContext,
  );

  const { healthCareAddOn, setHealthCareAddOn } = useContext(
    HealthCareAddOnContext,
  );

  const { currentCurrency, setCurrentCurrency } = useContext(
    CurrentCurrencyContext,
  );

  const { valueMealAddon, setValueMealAddOn } = useContext(
    ValueMealAddonContext,
  );

  const token = getToken();
  const checkReschedule = checkIsReschedule();
  const [loading, setLoading] = useState(false);

  let TotalBusFare = parseFloat(sessionStorageGetItem('busFare'));

  let selected_origin = sessionStorageGetItem('Origin_data');
  var _obj_selected_origin = JSON.parse(selected_origin);

  let original_addon_data = getSelectedAddOnData();
  let original_addon_sessionID = sessionStorageGetItem('addOnSession');

  let rescheduleAmount = sessionStorageGetItem('rescheduleAmount');
  let _depart_data = JSON.parse(sessionStorageGetItem('departData'));
  let _return_data = JSON.parse(sessionStorageGetItem('returnData'));
  let _depart_data_multi_modal = JSON.parse(
    sessionStorageGetItem('departDataMultiModal'),
  );
  let private_hire_amount = 0;
  if (_depart_data_multi_modal) {
    private_hire_amount = parseFloat(
      _depart_data_multi_modal?.fare * passenger_count,
    ).toFixed(2);
  }

  let selected_destination = sessionStorageGetItem('Destination_data');
  var _obj_selected_destination = JSON.parse(selected_destination);

  const navigate = useNavigate();

  const redirectToPaymentGateway = (event) => {
    tokenIsValid();

    if (sessionStorageGetItem('departData') == null) {
      alert('Error while checkout');
      window.location.href = '/';
      return;
    }

    let addon_data = getSelectedAddOnData();
    let original_addon_data = getSelectedAddOnData(); // Re-read, though originally it was read outside.
    // Simplifying checks for brevity, but retaining validations

    // ... validation logic ...

    if (
      VoucherCode === 'AA1TOFLY' &&
      (VoucherCodeAirlineNo == null || VoucherCodeAirlineNo === '')
    ) {
      event.preventDefault();
      alert('Please enter valid AirAsia boarding code');
      return;
    }

    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        primary_guest_email,
      ) == false
    ) {
      event.preventDefault();
      alert('Please enter your email in format: yourname@example.com');
      return;
    }

    if (primary_guest_contact == null || primary_guest_contact.trim() == '') {
      event.preventDefault();
      alert('Please enter your phone number');
      return;
    }

    if (guests.length < passenger_count) {
      event.preventDefault();
      alert('All fields are mandatory');
      return;
    }

    // Check individual guests
    for (let i = 0; i < guests.length; i++) {
      // guests[i].dob = guests[i].dob || moment().format('YYYY-MM-DD');
      guests[i].ticket_type = guests[i].ticket_type || 'A';

      const element = guests[i];

      if (
        !element.guest_name ||
        !element.dob ||
        !element.gender ||
        !element.nationality ||
        !(element.ic || element.passport)
      ) {
        alert('All guest fields are mandatory');
        return;
      }
      // More detailed checks can be kept if needed
    }

    // If all valid:
    sessionStorageSetItem('bookingGuestDetails', JSON.stringify(guests));
    sessionStorageSetItem(
      'bookingContactInfo',
      JSON.stringify({
        email: primary_guest_email,
        contact: primary_guest_contact,
        countryCode: phone_country_code,
      }),
    );
    sessionStorageSetItem('passengerCount', passenger_count);

    // calling reserve api to return the following data
    // {
    // 	"fare": 40,
    // 	"addOns": 5,
    // 	"discount": 10,
    // 	"handling": 0,
    // 	"facility": 0,
    // 	"qrCharge": 0,
    // 	"final": 35
    // }

    navigate('/bookingSummary');
  };

  return (
    <>
      {loading && (
        <div className='center'>
          <LoadingScreenModal />
        </div>
      )}
      <h3 className='tnc_text'>
        By clicking ‘{children}’ I acknowledge that I have read and accept the{' '}
        <a href='https://www.causewaylink.com.my/help/' target='_blank'>
          {' '}
          Rules & Restrictions
        </a>
        ,{' '}
        <a href='https://www.causewaylink.com.my/help/' target='_blank'>
          {' '}
          Terms of Use
        </a>{' '}
        and{' '}
        <a href='https://www.causewaylink.com.my/help/' target='_blank'>
          {' '}
          Privacy Policy
        </a>
        .
      </h3>

      {currentCurrency !== 'MYR' && (
        <div
          className='important-note'
          style={{
            padding: '0 20px 20px',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <span
            style={{
              backgroundColor: 'red',
              marginRight: '5px',
              minWidth: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className='oval'
          >
            i
          </span>
          Note: The final payment will be processed in MYR if your selected
          currency is not MYR.
        </div>
      )}

      <button
        type='button'
        className='btn--print--ticket--full--width btn--ticket'
        onClick={redirectToPaymentGateway}
        // params={[window.location.search.replace('?', '')]}
      >
        {children}
      </button>

      <Row className='p-4'>
        <Col sm={1}>
          <span className='oval'>i</span>
        </Col>
        <Col sm={11}>
          <h4 className='secure_text'>
            We use secure transmission and encrypted storage to protect your
            personal information.
          </h4>
        </Col>
      </Row>
    </>
  );
};
